module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Account":{"widgets.support.widget":[{"value":"BillingSupport_Support","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.SitePage_Account","_fox_":1}],"widgets.userNotificationsManager.widget":[{"value":"UserNotificationsManager","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.SitePage_Account","_fox_":1}],"widgets.userProfile.widget":[{"value":"UserProfile","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101007},"path":"~.SitePage_Account","_fox_":1}],"widgets.userPersonalData.widget":[{"value":"UserPersonalData","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101009},"path":"~.SitePage_Account","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/sitepage/account.js
// module id = 709
// module chunks = 4